<script setup lang="ts">
/**
 * The warning of the place on screen, as a box to read and click away. It opens by itself
 * when such a place is chosen, and from the icon beside the place's name. The catalog breaks
 * its text with //, which become paragraphs.
 */
import { computed } from 'vue'
import { useAppStore } from '../store'

const store = useAppStore()
const paragraphs = computed(() => (store.placeWarning ?? '').split(/\s*\/\/\s*/).filter(Boolean))
</script>

<template>
  <div v-if="store.warningOpen && store.placeWarning" class="modal placewarning" role="alertdialog" aria-modal="true" aria-labelledby="placewarning-title"
       @click.self="store.warningOpen = false">
    <div class="card">
      <h2 id="placewarning-title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 3.5 2.5 20h19L12 3.5z" /><path d="M12 10v4.5" /><path d="M12 17.3v.2" />
        </svg>
        {{ store.place?.name }}
      </h2>
      <p v-for="(p, i) in paragraphs" :key="i">{{ p }}</p>
      <div class="cardbuttons">
        <span></span>
        <button class="primary" @click="store.warningOpen = false">{{ store.t('noticeOk') }}</button>
      </div>
    </div>
  </div>
</template>
